import { Form, Input, Select, Button, Typography, Row, Col, DatePicker } from "antd";
import MainLayout from "@/components/PatientLayout/MainLayout.jsx";
import { useNavigate } from "react-router-dom";
import { stateOptions } from "@/config";
import { post } from "@/libs/axios.js";
import { useState } from "react";
const { Title, Text } = Typography;
const { Option } = Select;

const PatientEnrollmentForm = () => {
  const themeColor = localStorage.getItem("themeColor");
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm();
  const navigate = useNavigate();

  const onFinish = async (values) => {
    setLoading(true)

    try {
      console.log("Received values:", values);
      await post("sessions/register", values);

      navigate("/patient/signin");
    } catch (e) {
      console.log(e)
    } finally {
      setLoading(false)
    }
  };

  return (
    <MainLayout>
      <div className="mx-auto pl-10 pr-10">
        <Title level={2} style={{ color: themeColor }}>
          Patient Registration Page
        </Title>
        <hr className="p-2" />
        <Text style={{ fontWeight: 600 }}>
          Patients enroll here to check your copay account status.
        </Text>

        <div className="mt-10">
          <Form form={form} onFinish={onFinish} layout="vertical">
            <Row gutter={20}>
              <Col span={12}>
                <Form.Item
                  name="patient_first_name"
                  label="Patient first name"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="patient_last_name"
                  label="Patient last name"
                  rules={[{ required: true }]}
                >
                  <Input />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="date_of_birth"
                  label="Patient date of birth"
                  rules={[{ required: true }]}
                >
                  <DatePicker
                    format="MM-DD-YYYY"
                    placeholder="MM-DD-YYYY"
                    style={{ width: "200px" }}
                    required
                  />
                </Form.Item>
              </Col>

              <Col span={12}>
                <Form.Item
                  name="patient_gender_code"
                  label="Patient gender"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="Please select one" required>
                    <Option value={1}>Male</Option>
                    <Option value={2}>Female</Option>
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="patient_street_address"
                  label="Patient address"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Street address" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="patient_address_line2"
                  label="Patient address Line 2"
                >
                  <Input placeholder="Street address line 2" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="patient_state"
                  label="State"
                  rules={[{ required: true }]}
                >
                  <Select placeholder="State">
                    {stateOptions.map((option) => (
                      <Option value={option.value} key={option.value}>
                        {option.label}
                      </Option>
                    ))}
                  </Select>
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="patient_city_address"
                  label="City"
                  rules={[{ required: true }]}
                >
                  <Input placeholder="Location city" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item name="patient_zip" label="ZIP">
                  <Input placeholder="Location ZIP code (5-digits e.g. 91101)" />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={20}>
              <Col span={12}>
                <Form.Item
                  name="email"
                  label="Your email"
                  rules={[{ required: true, type: "email" }]}
                >
                  <Input />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="password"
                  label="Create a password"
                  rules={[{ required: true, min: 8 }]}
                >
                  <Input.Password placeholder="At least 8 characters long" />
                </Form.Item>
              </Col>
              <Col span={12}>
                <Form.Item
                  name="password_confirmation"
                  label="Confirm created password"
                  dependencies={["password"]}
                  rules={[
                    { required: true },
                    ({ getFieldValue }) => ({
                      validator(_, value) {
                        if (!value || getFieldValue("password") === value) {
                          return Promise.resolve();
                        }
                        return Promise.reject(
                          new Error("The two passwords do not match"),
                        );
                      },
                    }),
                  ]}
                >
                  <Input.Password />
                </Form.Item>
              </Col>
            </Row>


            <Form.Item
              wrapperCol={{
                offset: 8,
                span: 14,
              }}
            >
              <Button
                loading={loading}
                disabled={loading}
                type="primary"
                htmlType="submit"
                style={{
                  width: "60%",
                  backgroundColor: themeColor,
                  height: "40px",
                  fontSize: "18px",
                }}
              >
                Submit
              </Button>
            </Form.Item>
          </Form>
        </div>
      </div>
    </MainLayout>
  );
};

export default PatientEnrollmentForm;
